import { z } from 'zod';
import { BUSINESS_TYPES } from '../enums.js';
import { isReservedSlug, isValidSlug, SLUG_MAX_LENGTH, SLUG_MIN_LENGTH } from '../slug.js';
export const hexColorSchema = z
    .string()
    .trim()
    .regex(/^#[0-9a-fA-F]{6}$/, 'Usá un color hexadecimal, p. ej. #E11D48');
export const slugSchema = z
    .string()
    .trim()
    .toLowerCase()
    .min(SLUG_MIN_LENGTH, `Mínimo ${SLUG_MIN_LENGTH} caracteres`)
    .max(SLUG_MAX_LENGTH, `Máximo ${SLUG_MAX_LENGTH} caracteres`)
    .refine(isValidSlug, 'Solo minúsculas, números y guiones (sin guiones al principio o al final)')
    .refine((s) => !isReservedSlug(s), 'Ese nombre está reservado, probá con otro');
/** Texto opcional: '' se guarda como null en la API. */
const optionalText = (max) => z.string().trim().max(max).nullable().optional();
export const whatsappSchema = z
    .string()
    .trim()
    .regex(/^\+?[0-9 ()-]{8,20}$/, 'Número inválido (p. ej. +54 9 11 1234-5678)')
    .or(z.literal(''))
    .nullable()
    .optional();
export const instagramSchema = z
    .string()
    .trim()
    .regex(/^@?[A-Za-z0-9._]{1,30}$/, 'Usuario de Instagram inválido')
    .or(z.literal(''))
    .nullable()
    .optional();
export const timezoneSchema = z.string().trim().min(3).max(64);
// ---- Horarios ----------------------------------------------------------------
/** "HH:mm" 00:00–23:59. Si close < open, el rango cruza la medianoche. */
export const timeSchema = z
    .string()
    .regex(/^([01]\d|2[0-3]):[0-5]\d$/, 'Usá el formato HH:mm');
export const timeRangeSchema = z
    .object({ open: timeSchema, close: timeSchema })
    .refine((r) => r.open !== r.close, 'La apertura y el cierre no pueden ser iguales');
/** day: 0 = domingo … 6 = sábado (como Date#getDay). */
export const dayHoursSchema = z.object({
    day: z.number().int().min(0).max(6),
    ranges: z.array(timeRangeSchema).max(4, 'Máximo 4 franjas por día'),
});
export const openingHoursSchema = z
    .array(dayHoursSchema)
    .max(7)
    .refine((days) => new Set(days.map((d) => d.day)).size === days.length, 'Hay días repetidos');
export const updateHoursSchema = z.object({
    openingHours: openingHoursSchema,
});
// ---- Local -------------------------------------------------------------------
export const createLocalSchema = z.object({
    name: z.string().trim().min(2, 'Ingresá el nombre del local').max(80),
    slug: slugSchema,
    businessType: z.enum(BUSINESS_TYPES).default('HELADERIA'),
    primaryColor: hexColorSchema.optional(),
    logoUrl: z.url('URL inválida').or(z.literal('')).nullable().optional(),
});
export const updateLocalSchema = z.object({
    name: z.string().trim().min(2, 'Ingresá el nombre del local').max(80).optional(),
    description: optionalText(500),
    address: optionalText(200),
    whatsapp: whatsappSchema,
    instagram: instagramSchema,
    businessType: z.enum(BUSINESS_TYPES).optional(),
    timezone: timezoneSchema.optional(),
    businessDayStartHour: z.number().int().min(0).max(12).optional(),
});
export const updateBrandingSchema = z.object({
    logoUrl: z.url('URL inválida').or(z.literal('')).nullable().optional(),
    primaryColor: hexColorSchema.optional(),
    secondaryColor: hexColorSchema.optional(),
    hideBranding: z.boolean().optional(),
});
export const publishLocalSchema = z.object({
    published: z.boolean().default(true),
});
export const checkSlugQuerySchema = z.object({
    slug: z.string().trim().toLowerCase().min(1).max(80),
});
//# sourceMappingURL=locals.js.map